import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Badge, Alert, Table, Accordion, Spinner, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop } from '@fortawesome/free-solid-svg-icons'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ModalNuevaSuscripcion from './Modales/ModalNuevaSuscripcion';
import ModalSeguroCancelarSuscripcion from './Modales/ModalSeguroCancelarSuscripcion';
import ModalSeguroRecuperarSuscripcion from './Modales/ModalSeguroRecuperarSuscripcion';
import { faDesktop } from '@fortawesome/free-solid-svg-icons';
import { useToast } from 'context/providers/ToastProvider';

const SeccionSuscripciones = ({
    idCliente
}) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [suscripciones, setSuscripciones] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [ordenesSuscripcion, setOrdenesSuscripcion] = useState({});
    const [cargandoOrdenes, setCargandoOrdenes] = useState({});
    const [paginaOrdenes, setPaginaOrdenes] = useState({});
    const [hasMoreOrdenes, setHasMoreOrdenes] = useState({});
    const [totalOrdenes, setTotalOrdenes] = useState({});
    const [showModalNuevaSuscripcion, setShowModalNuevaSuscripcion] = useState(false);
    const [linkCopiado, setLinkCopiado] = useState({});
    const [cancelandoId, setCancelandoId] = useState(null);
    const [showModalCancelar, setShowModalCancelar] = useState(false);
    const [suscripcionACancelar, setSuscripcionACancelar] = useState(null);
    const [recuperandoId, setRecuperandoId] = useState(null);
    const [showModalRecuperar, setShowModalRecuperar] = useState(false);
    const [suscripcionARecuperar, setSuscripcionARecuperar] = useState(null);
    const [productosOrdenPrincipal, setProductosOrdenPrincipal] = useState({});
    const [cargandoProductos, setCargandoProductos] = useState({});
    const [licenciasServidor, setLicenciasServidor] = useState({}); // 🆕 Nuevo estado para licencias servidor

    /**
     * Obtiene las suscripciones del cliente
     */
    const obtenerSuscripcionesCliente = async () => {
        setCargando(true);

        try {

            const response = await fetch(`/api/Suscripciones/ObtenerSuscripciones?idCliente=${idCliente}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {

                const data = await response.json();

                if (data.iResponseType === 1) {
                    let detalles = [];
                    let licenciasServidorMap = {}; // 🆕 Mapa de licencias servidor

                    try {
                        const ObjDetalles = JSON.parse(data.detalles);

                        // Patrón estándar del SP: siempre será un objeto con tablas
                        detalles = ObjDetalles.table2 || [];

                        // 🆕 Procesar Table3 con licencias servidor vinculadas
                        if (ObjDetalles.table3 && Array.isArray(ObjDetalles.table3)) {
                            ObjDetalles.table3.forEach(licServidor => {
                                licenciasServidorMap[licServidor.idSuscripcion] = {
                                    idLicenciaServidor: licServidor.idLicenciaServidor,
                                    vUUIDLicenciaServidor: licServidor.vUUIDLicenciaServidor,
                                    vTipoLicenciaServidor: licServidor.vTipoLicenciaServidor
                                };
                            });
                        }
                    } catch (parseError) {
                        console.error('Error parsing detalles:', parseError);
                        detalles = [];
                    }

                    setSuscripciones(detalles);
                    setLicenciasServidor(licenciasServidorMap); // 🆕 Guardar mapa de licencias servidor

                    // Inicializar estados para cada suscripción
                    const initialStates = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialStates[id] = [];
                    });

                    setOrdenesSuscripcion(initialStates);

                    // Inicializar paginación y hasMore para cada suscripción
                    const initialPagination = {};
                    const initialHasMore = {};
                    const initialTotal = {};
                    detalles.forEach(suscripcion => {
                        const id = suscripcion.idSuscripcion.toString();
                        initialPagination[id] = 1;
                        initialHasMore[id] = true;
                        initialTotal[id] = 0;
                    });

                    setPaginaOrdenes(initialPagination);
                    setHasMoreOrdenes(initialHasMore);
                    setTotalOrdenes(initialTotal);

                } else {
                    showErrorToast(data.vMessage);
                }

            } else {
                console.error('❌ Response not OK:', response.status, response.statusText);
                showErrorToast(`Error ${response.status}: ${response.statusText}`);

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('❌ Error completo:', error);
            showErrorToast('Hubo un problema con la petici&oacute;n: ' + error.message);
        }

        setCargando(false);
    };

    /**
     * Obtiene más órdenes para el scroll infinito
     */
    const fetchMoreOrdenes = async (idSuscripcion) => {
        try {
            setCargandoOrdenes(prev => ({ ...prev, [idSuscripcion]: true }));

            const requestBody = {
                idSuscripcion: idSuscripcion,
                pagina: paginaOrdenes[idSuscripcion] || 1,
                tamanioPagina: 5
            };

            const response = await fetch('/api/Suscripciones/ObtenerOrdenesSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(requestBody)
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const nuevasOrdenes = parsed.table2 || [];
                    const total = parsed.table3?.[0]?.totalOrdenes || 0;

                    setTotalOrdenes(prev => ({ ...prev, [idSuscripcion]: total }));

                    if (nuevasOrdenes && nuevasOrdenes.length > 0) {
                        if (paginaOrdenes[idSuscripcion] === 1) {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: nuevasOrdenes
                            }));
                        } else {
                            setOrdenesSuscripcion(prev => ({
                                ...prev,
                                [idSuscripcion]: [...(prev[idSuscripcion] || []), ...nuevasOrdenes]
                            }));
                        }

                        setPaginaOrdenes(prev => ({
                            ...prev,
                            [idSuscripcion]: (prev[idSuscripcion] || 1) + 1
                        }));

                        if (nuevasOrdenes.length < 5) {
                            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                        }
                    } else {
                        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                    }
                } else {
                    showErrorToast(data.vMessage);
                    setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
                }
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
            }
        } catch (error) {
            showErrorToast('Error al obtener órdenes: ' + error.message);
            setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
        } finally {
            setCargandoOrdenes(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Reinicia y carga las órdenes de una suscripción desde cero
     */
    const cargarOrdenesIniciales = async (idSuscripcion) => {
        // Resetear estados para esta suscripción
        setOrdenesSuscripcion(prev => ({ ...prev, [idSuscripcion]: [] }));
        setPaginaOrdenes(prev => ({ ...prev, [idSuscripcion]: 1 }));
        setHasMoreOrdenes(prev => ({ ...prev, [idSuscripcion]: true }));

        // Cargar primera página
        await fetchMoreOrdenes(idSuscripcion);
    };

    /**
     * Renderiza el badge del estatus de la suscripción
     */
    const renderBadgeEstatus = (iStatus) => {
        const estatusConfig = {
            0: { bg: 'warning', text: 'PENDIENTE' },
            1: { bg: 'success', text: 'ACTIVA' },
            2: { bg: 'danger', text: 'CANCELADA' },
            3: { bg: 'secondary', text: 'SUSPENDIDA' }
        };

        const config = estatusConfig[iStatus] || { bg: 'secondary', text: 'DESCONOCIDO' };

        return (
            <Badge bg={config.bg} className="me-2">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza el badge del estatus de una orden
     */
    const renderBadgeEstatusOrden = (estatus) => {
        const estatusConfig = {
            'Pagada': { bg: 'success', text: 'PAGADA' },
            'Pendiente': { bg: 'warning', text: 'PENDIENTE' },
            'Cancelada': { bg: 'danger', text: 'CANCELADA' },
            'Procesando': { bg: 'info', text: 'PROCESANDO' }
        };

        const config = estatusConfig[estatus] || { bg: 'secondary', text: estatus };

        return (
            <Badge bg={config.bg} size="sm">
                {config.text}
            </Badge>
        );
    };

    /**
     * Renderiza la información de periodicidad
     */
    const renderPeriodicidad = (tipoSuscripcion) => {
        const periodicidadConfig = {
            'Mensual': { icon: 'calendar-alt', color: 'text-primary' },
            'Trimestral': { icon: 'calendar-alt', color: 'text-info' },
            'Semestral': { icon: 'calendar-alt', color: 'text-warning' },
            'Anual': { icon: 'calendar-alt', color: 'text-success' }
        };

        const config = periodicidadConfig[tipoSuscripcion] || { color: 'text-muted' };

        return (
            <span className={config.color}>
                <FontAwesomeIcon icon={config.icon} className="me-1" />
                {tipoSuscripcion}
            </span>
        );
    };

    /**
     * Copia el link de pago al portapapeles usando el endpoint GetPaymentLink
     * ✅ IGUAL QUE EN LinkPago.js - Sin mostrar toast para evitar conflictos
     */
    const copiarLinkPago = async (vUUIDLinkPago, idSuscripcion) => {
        try {
            const response = await fetch(`/api/orden/GetPaymentLink?vUUIDLinkPago=${vUUIDLinkPago}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
                return null;
            });

            if (response && response.ok) {
                const data = await response.json();
                console.log('Data: ' + data.vMessage);

                if (data.iResponseType === 1) {
                    let copiadoExitoso = false;

                    // Método alternativo para iOS
                    try {
                        await navigator.clipboard.writeText(data.vMessage);
                        copiadoExitoso = true;
                    } catch (clipboardError) {
                        // Fallback para iOS usando un elemento temporal
                        const textArea = document.createElement('textarea');
                        textArea.value = data.vMessage;
                        textArea.style.position = 'fixed';
                        textArea.style.left = '-999999px';
                        textArea.style.top = '-999999px';
                        document.body.appendChild(textArea);
                        textArea.focus();
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            copiadoExitoso = true;
                        } catch (execError) {
                            console.error('Error al copiar con execCommand:', execError);
                        }

                        document.body.removeChild(textArea);
                    }

                    if (copiadoExitoso) {
                        setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: true }));

                        setTimeout(() => {
                            setLinkCopiado(prev => ({ ...prev, [idSuscripcion]: false }));
                        }, 2000);
                    } else {
                        showErrorToast('No se pudo copiar el enlace. Por favor, cópialo manualmente.');
                    }
                } else {
                    showErrorToast(data.vMessage);
                }
            } else {
                showErrorToast(response?.status + ' ' + response?.statusText);
                console.log(response);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
            showErrorToast('Error al obtener el enlace de pago');
        }
    };

    /**
     * Maneja la expansión de un accordion item
     */
    const handleAccordionExpand = (idSuscripcion) => {
        // Si no hay órdenes cargadas para esta suscripción, cargar iniciales
        if (!ordenesSuscripcion[idSuscripcion] || ordenesSuscripcion[idSuscripcion].length === 0) {
            cargarOrdenesIniciales(idSuscripcion);
        }

        // Si no hay productos cargados para esta suscripción, cargarlos
        if (!productosOrdenPrincipal[idSuscripcion]) {
            obtenerProductosOrdenPrincipal(idSuscripcion);
        }
    };

    /**
     * Obtiene los productos de la orden principal de una suscripción
     */
    const obtenerProductosOrdenPrincipal = async (idSuscripcion) => {
        try {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: true }));

            const response = await fetch(`/api/Suscripciones/ObtenerProductosOrdenPrincipal?idSuscripcion=${idSuscripcion}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    const parsed = JSON.parse(data.detalles);
                    const productos = parsed.table2 || [];

                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: productos
                    }));
                } else {
                    showErrorToast(data.vMessage);
                    setProductosOrdenPrincipal(prev => ({
                        ...prev,
                        [idSuscripcion]: []
                    }));
                }
            } else {
                showErrorToast(`Error ${response.status}: ${response.statusText}`);
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                setProductosOrdenPrincipal(prev => ({
                    ...prev,
                    [idSuscripcion]: []
                }));
            }
        } catch (error) {
            showErrorToast('Error al obtener productos: ' + error.message);
            setProductosOrdenPrincipal(prev => ({
                ...prev,
                [idSuscripcion]: []
            }));
        } finally {
            setCargandoProductos(prev => ({ ...prev, [idSuscripcion]: false }));
        }
    };

    /**
     * Abre el modal de confirmación para cancelar suscripción
     */
    const abrirModalCancelar = (suscripcion) => {
        setSuscripcionACancelar(suscripcion);
        setShowModalCancelar(true);
    };

    /**
     * Cancela una suscripción
     */
    const cancelarSuscripcion = async () => {
        if (!suscripcionACancelar) return;

        try {
            setCancelandoId(suscripcionACancelar.idSuscripcion);

            const response = await fetch('/api/Suscripciones/CancelarSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionACancelar.idSuscripcion,
                    motivoCancelacion: 'Cancelación solicitada desde el panel'
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Suscripción cancelada correctamente');
                    await obtenerSuscripcionesCliente(); // refrescar lista
                } else {
                    showErrorToast(data.vMessage || 'No fue posible cancelar la suscripción');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`${response.status} ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al cancelar la suscripción: ' + error.message);
        } finally {
            setCancelandoId(null);
            setShowModalCancelar(false);
            setSuscripcionACancelar(null);
        }
    };

    /**
     * Abre el modal de confirmación para recuperar suscripción
     */
    const abrirModalRecuperar = (suscripcion) => {
        setSuscripcionARecuperar(suscripcion);
        setShowModalRecuperar(true);
    };

    /**
     * Recupera una suscripción cancelada
     */
    const recuperarSuscripcion = async () => {
        if (!suscripcionARecuperar) return;

        try {
            setRecuperandoId(suscripcionARecuperar.idSuscripcion);

            const response = await fetch('/api/Suscripciones/RecuperarSuscripcion', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    idSuscripcion: suscripcionARecuperar.idSuscripcion
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || 'Suscripción recuperada correctamente');
                    await obtenerSuscripcionesCliente(); // refrescar lista
                } else {
                    showErrorToast(data.vMessage || 'No fue posible recuperar la suscripción');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                showErrorToast(`${response.status} ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al recuperar la suscripción: ' + error.message);
        } finally {
            setRecuperandoId(null);
            setShowModalRecuperar(false);
            setSuscripcionARecuperar(null);
        }
    };

    useEffect(() => {
        console.log('🔍 SeccionSuscripciones mounted');
        console.log('🔍 idCliente:', idCliente);
        if (idCliente) {
            obtenerSuscripcionesCliente();
        }
    }, [idCliente]);

    return (
        <ErrorBoundary>
            <Card>
                <Card.Header>
                    <Row className="align-items-center">
                        <Col>
                            <h5 className="mb-0">
                                <FontAwesomeIcon icon="sync-alt" className="me-2 text-primary" />
                                Suscripciones
                            </h5>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center gap-2">
                            {suscripciones.length > 0 && (
                                <Badge bg="info" className="me-2">
                                    {suscripciones.length} suscripci&oacute;n{suscripciones.length !== 1 ? 'es' : ''}
                                </Badge>
                            )}
                            <Button
                                variant="success"
                                size="sm"
                                className="d-flex align-items-center"
                                onClick={() => setShowModalNuevaSuscripcion(true)}
                            >
                                <FontAwesomeIcon icon="plus" className="me-1" />
                                Nueva Suscripci&oacute;n
                            </Button>
                        </Col>
                    </Row>
                </Card.Header>

                <Card.Body className="border-top fs--1">
                    {cargando ? (
                        <div className="p-3">
                            <Row>
                                {[1, 2].map((item) => (
                                    <Col lg={6} key={item} className="mb-3">
                                        <div className="border rounded-3 p-3">
                                            <Skeleton height={20} width="60%" className="mb-2" />
                                            <Skeleton height={16} width="40%" className="mb-2" />
                                            <Skeleton height={14} width="80%" className="mb-2" />
                                            <Skeleton height={14} width="70%" />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ) : suscripciones.length > 0 ? (
                        <Accordion
                            defaultActiveKey=""
                            onSelect={(eventKey) => {
                                if (eventKey) {
                                    const suscripcionIndex = parseInt(eventKey);
                                    const suscripcion = suscripciones[suscripcionIndex];
                                    if (suscripcion) {
                                        handleAccordionExpand(suscripcion.idSuscripcion.toString());
                                    }
                                }
                            }}
                        >
                            {suscripciones.map((suscripcion, index) => (
                                <Accordion.Item eventKey={index.toString()} key={index} className="mb-2">
                                    <Accordion.Header>
                                        <div className="w-100 d-flex justify-content-between align-items-center me-3">
                                            <div className="d-flex align-items-center">
                                                <Badge bg="primary" className="me-2">
                                                    #{suscripcion.idSuscripcion}
                                                </Badge>
                                                <span className="fw-bold">{suscripcion.vNombreSuscripcion}</span>
                                                <span className="ms-2">{renderBadgeEstatus(suscripcion.iStatus)}</span>
                                            </div>
                                            <div className="text-end">
                                                <span className="fw-bold text-success">
                                                    ${parseFloat(suscripcion.dPrecio || 0).toLocaleString('es-MX', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} {suscripcion.vMoneda || 'MXN'}
                                                </span>
                                                <div className="small text-muted">
                                                    {renderPeriodicidad(suscripcion.vTipoSuscripcion)}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col lg={6}>
                                                <h6 className="fw-bold mb-3">
                                                    <FontAwesomeIcon icon="info-circle" className="me-2 text-info" />
                                                    Informaci&oacute;n de la Suscripci&oacute;n
                                                </h6>
                                                <Table size="sm" className="mb-3">
                                                    <tbody>
                                                        {suscripcion.iStatus === 2 ? (
                                                            <>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <small className="text-muted fw-bold">Fecha de cancelaci&oacute;n:</small>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <span className="text-danger fw-bold">
                                                                            {suscripcion.dUpdatedDate ?
                                                                                new Date(suscripcion.dUpdatedDate).toLocaleDateString('es-MX', {
                                                                                    day: '2-digit',
                                                                                    month: 'short',
                                                                                    year: 'numeric'
                                                                                }) :
                                                                                'N/A'
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <small className="text-muted fw-bold">Creada:</small>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <FontAwesomeIcon icon="clock" className="me-1 text-muted" />
                                                                        {new Date(suscripcion.dFechaCreacion).toLocaleDateString('es-MX', {
                                                                            day: '2-digit',
                                                                            month: 'short',
                                                                            year: 'numeric'
                                                                        }
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {suscripcion.idLicencia && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <small className="text-muted fw-bold">
                                                                                {suscripcion.vTipoLicencia === 'POS Servidor' ? 'Licencia Servidor:' : 'Licencia Principal:'}
                                                                            </small>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            <Link to={`/licencias/detalle/${suscripcion.idLicencia}`} className="fw-600 text-decoration-none">
                                                                                <FontAwesomeIcon icon={faLaptop} className="me-1 text-primary" />
                                                                                #{suscripcion.idLicencia} - {suscripcion.vTipoLicencia}
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {!suscripcion.idLicencia && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <small className="text-muted fw-bold">Licencia Principal:</small>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            <span className="text-muted">Sin licencia asignada</span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {/* Nueva fila: Licencia Servidor Vinculada (solo para licencias Nube) */}
                                                                {suscripcion.vTipoLicencia?.includes("Nube") && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <small className="text-muted fw-bold">Licencia Servidor:</small>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            {licenciasServidor[suscripcion.idSuscripcion] && licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor ? (
                                                                                <Link
                                                                                    to={`/licencias/detalle/${licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor}`}
                                                                                    className="fw-600 text-decoration-none"
                                                                                >
                                                                                    <FontAwesomeIcon icon={faDesktop} className="me-1 text-primary" />
                                                                                    #{licenciasServidor[suscripcion.idSuscripcion].idLicenciaServidor} - Servidor

                                                                                </Link>
                                                                            ) : (
                                                                                <span className="text-warning">
                                                                                    <FontAwesomeIcon icon="unlink" className="me-1" />
                                                                                    Sin vinculación a servidor
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {suscripcion.iStatus === 1 && (
                                                                    <tr>
                                                                        <td className="border-0 ps-0 py-1">
                                                                            <small className="text-muted fw-bold">Pr&oacute;ximo pago:</small>
                                                                        </td>
                                                                        <td className="border-0 py-1">
                                                                            <span className="text-primary fw-bold">
                                                                                <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                {suscripcion.dProximoPago ?
                                                                                    new Date(suscripcion.dProximoPago).toLocaleDateString('es-MX', {
                                                                                        day: '2-digit',
                                                                                        month: 'short',
                                                                                        year: 'numeric'
                                                                                    }) :
                                                                                    'N/A'
                                                                                }
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                <tr>
                                                                    <td className="border-0 ps-0 py-1">
                                                                        <small className="text-muted fw-bold">Creada:</small>
                                                                    </td>
                                                                    <td className="border-0 py-1">
                                                                        <FontAwesomeIcon icon="clock" className="me-1 text-muted" />
                                                                        {new Date(suscripcion.dFechaCreacion).toLocaleDateString('es-MX')}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )}
                                                        {suscripcion.vUUIDLinkPago && suscripcion.iStatusLink === 0 && (
                                                            <tr>
                                                                <td className="border-0 ps-0 py-1">
                                                                    <small className="text-muted fw-bold">Link de pago:</small>
                                                                </td>
                                                                <td className="border-0 py-1">
                                                                    <span
                                                                        className={`me-3 text-break ${linkCopiado[suscripcion.idSuscripcion] ? "text-secondary" : "text-primary"}`}
                                                                        style={{
                                                                            cursor: suscripcion.iStatusLink === 0 ? "pointer" : "default",
                                                                            transition: "color 0.2s ease"
                                                                        }}
                                                                        onClick={suscripcion.iStatusLink === 0 ? () => copiarLinkPago(suscripcion.vUUIDLinkPago, suscripcion.idSuscripcion) : undefined}
                                                                    >
                                                                        <strong>
                                                                            {linkCopiado[suscripcion.idSuscripcion]
                                                                                ? "¡Copiado!"
                                                                                : suscripcion.iStatusLink === 0
                                                                                    ? `Copiar link de pago`
                                                                                    : ``
                                                                            }
                                                                        </strong>
                                                                    </span>


                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>


                                                {/* Tabla de Productos de la Suscripción */}
                                                <div className="mt-3">
                                                    <h6 className="fw-bold mb-2">
                                                        <FontAwesomeIcon icon="box" className="me-2 text-primary" />
                                                        Productos de la Suscripción
                                                    </h6>
                                                    {cargandoProductos[suscripcion.idSuscripcion] ? (
                                                        <div className="d-flex justify-content-center align-items-center py-3">
                                                            <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                            <small className="text-muted">Cargando productos...</small>
                                                        </div>
                                                    ) : productosOrdenPrincipal[suscripcion.idSuscripcion] && productosOrdenPrincipal[suscripcion.idSuscripcion].length > 0 ? (
                                                        <div className="table-responsive">
                                                            <Table size="sm" bordered hover className="mb-0">
                                                                <thead className="bg-light">
                                                                    <tr>
                                                                        <th className="border-200">Cód. Barras</th>
                                                                        <th className="border-200">Nombre Producto</th>
                                                                        <th className="border-200 text-center">Cantidad</th>
                                                                        <th className="border-200 text-end">Prec. Unit.</th>
                                                                        <th className="border-200 text-end">Importe</th>
                                                                        <th className="border-200 text-end">IVA</th>
                                                                        <th className="border-200 text-end">Total</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {productosOrdenPrincipal[suscripcion.idSuscripcion].map((producto, idx) => (
                                                                        <tr key={idx}>
                                                                            <td className="align-middle">
                                                                                <small className="text-nowrap">{producto.vCodigoBarras}</small>
                                                                            </td>
                                                                            <td className="align-middle">
                                                                                <small>{producto.vNombreProducto}</small>
                                                                            </td>
                                                                            <td className="align-middle text-center">
                                                                                <small>{producto.dCantidad}</small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat((producto.dImporte - producto.dDescuento + producto.dIVA) / producto.dCantidad).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat(producto.dImporte).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                                {producto.dDescuento > 0 && (
                                                                                    <>
                                                                                        <br />
                                                                                        <Badge bg="danger" size="sm">
                                                                                            -{parseFloat(producto.dDescuento).toLocaleString('es-MX', {
                                                                                                minimumFractionDigits: 2,
                                                                                                maximumFractionDigits: 2,
                                                                                                style: 'currency',
                                                                                                currency: 'MXN'
                                                                                            })}
                                                                                        </Badge>
                                                                                    </>
                                                                                )}
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small>
                                                                                    {parseFloat(producto.dIVA).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                            <td className="align-middle text-end">
                                                                                <small className="fw-bold text-success">
                                                                                    {parseFloat(producto.dTotal).toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                                </small>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                                <tfoot className="bg-light">
                                                                    <tr>
                                                                        <td colSpan="6" className="text-end fw-bold">
                                                                            <small>Total:</small>
                                                                        </td>
                                                                        <td className="text-end">
                                                                            <small className="fw-bold text-success">
                                                                                {productosOrdenPrincipal[suscripcion.idSuscripcion]
                                                                                    .reduce((sum, p) => sum + parseFloat(p.dTotal), 0)
                                                                                    .toLocaleString('es-MX', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                        style: 'currency',
                                                                                        currency: 'MXN'
                                                                                    })}
                                                                            </small>
                                                                        </td>
                                                                    </tr>
                                                                </tfoot>
                                                            </Table>
                                                        </div>
                                                    ) : (
                                                        <Alert variant="light" className="text-center py-4 mb-0">
                                                            <FontAwesomeIcon icon="box-open" className="me-1" />
                                                            <div className="text-muted">No hay productos en la orden principal</div>
                                                        </Alert>
                                                    )}
                                                </div>

                                                <div className="mb-2 mt-3">
                                                    {suscripcion.iStatus === 2 ? (
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            className="d-flex align-items-center"
                                                            onClick={() => abrirModalRecuperar(suscripcion)}
                                                            disabled={recuperandoId === suscripcion.idSuscripcion}
                                                        >
                                                            {recuperandoId === suscripcion.idSuscripcion ? (
                                                                <Spinner animation="border" size="sm" className="me-2" />
                                                            ) : (
                                                                <FontAwesomeIcon icon="redo" className="me-1" />
                                                            )}
                                                            {recuperandoId === suscripcion.idSuscripcion ? 'Recuperando...' : 'Recuperar Suscripción'}
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            className="d-flex align-items-center"
                                                            onClick={() => abrirModalCancelar(suscripcion)}
                                                            disabled={cancelandoId === suscripcion.idSuscripcion || suscripcion.iStatus === 2}
                                                        >
                                                            {cancelandoId === suscripcion.idSuscripcion ? (
                                                                <Spinner animation="border" size="sm" className="me-2" />
                                                            ) : (
                                                                <FontAwesomeIcon icon="ban" className="me-1" />
                                                            )}
                                                            {cancelandoId === suscripcion.idSuscripcion ? 'Cancelando...' : 'Cancelar Suscripción'}
                                                        </Button>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <h6 className="fw-bold mb-0">
                                                        <FontAwesomeIcon icon="shopping-cart" className="me-2 text-success" />
                                                        &Oacute;rdenes Relacionadas
                                                        {totalOrdenes[suscripcion.idSuscripcion] > 0 && (
                                                            <Badge bg="primary" className="ms-2">
                                                                {totalOrdenes[suscripcion.idSuscripcion]}
                                                            </Badge>
                                                        )}
                                                    </h6>
                                                </div>

                                                <div
                                                    className="border rounded-3 p-2 bg-light"
                                                    style={{ maxHeight: '350px', overflowY: 'auto' }}
                                                    id={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                >
                                                    {ordenesSuscripcion[suscripcion.idSuscripcion] && ordenesSuscripcion[suscripcion.idSuscripcion].length > 0 ? (
                                                        <InfiniteScroll
                                                            dataLength={ordenesSuscripcion[suscripcion.idSuscripcion].length}
                                                            next={() => fetchMoreOrdenes(suscripcion.idSuscripcion.toString())}
                                                            hasMore={hasMoreOrdenes[suscripcion.idSuscripcion] || false}
                                                            loader={
                                                                <div className="d-flex justify-content-center alignItems-center py-2">
                                                                    <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                                    <small className="text-muted">Cargando m&aacute;s &oacute;rdenes...</small>
                                                                </div>
                                                            }
                                                            scrollableTarget={`scrollableTargetOrdenes-${suscripcion.idSuscripcion}`}
                                                            scrollThreshold={0.70}
                                                            style={{ overflowX: 'hidden' }}
                                                            endMessage={
                                                                ordenesSuscripcion[suscripcion.idSuscripcion].length > 0 && (
                                                                    <div className="text-center py-2 border-top mt-2">
                                                                        <small className="text-muted">
                                                                            <FontAwesomeIcon icon="shopping-cart" className="me-1" />
                                                                            Sin m&aacute;s &oacute;rdenes
                                                                        </small>
                                                                    </div>
                                                                )
                                                            }
                                                        >
                                                            {ordenesSuscripcion[suscripcion.idSuscripcion].map((orden, ordenIndex) => (
                                                                <div key={ordenIndex} className={`pb-3 mb-3 ${ordenIndex < ordenesSuscripcion[suscripcion.idSuscripcion].length - 1 ? 'border-bottom' : ''}`}>
                                                                    <div className={`d-flex justify-content-between align-items-start p-2 rounded-3 ${orden.bEsOrdenPrimaria ? 'bg-primary bg-opacity-10 border border-primary border-opacity-25' : ''}`}>
                                                                        <div className="flex-grow-1">
                                                                            <div className="d-flex align-items-center">
                                                                                <Link to={`/ordenes/detalle/${orden.idOrden}`} className="fw-600 text-decoration-none d-block">
                                                                                    <FontAwesomeIcon icon="shopping-cart" className="me-1 text-primary" />
                                                                                    Orden #{orden.idOrden}
                                                                                </Link>
                                                                                {orden.bEsOrdenPrimaria === 1 && (
                                                                                    <Badge bg="primary" size="sm" className="ms-2">
                                                                                        <FontAwesomeIcon icon="star" className="me-1" />
                                                                                        INICIAL
                                                                                    </Badge>
                                                                                )}
                                                                            </div>
                                                                            <div className="small text-muted mt-1">
                                                                                <FontAwesomeIcon icon="calendar-alt" className="me-1" />
                                                                                {new Date(orden.dFechaCreacion).toLocaleDateString('es-MX')}
                                                                            </div>
                                                                            {orden.vDescripcion && (
                                                                                <div className="small text-muted mt-1">
                                                                                    <FontAwesomeIcon icon="sticky-note" className="me-1" />
                                                                                    {orden.vDescripcion}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="text-end ms-3">
                                                                            {renderBadgeEstatusOrden(orden.vEstatus)}
                                                                            <div className="fw-bold text-success small mt-1">
                                                                                ${parseFloat(orden.dTotal || 0).toLocaleString('es-MX', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })} {orden.vMoneda || 'MXN'}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            ))}
                                                        </InfiniteScroll>
                                                    ) : cargandoOrdenes[suscripcion.idSuscripcion] ? (
                                                        <div className="d-flex justify-content-center align-items-center py-4">
                                                            <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                            <small className="text-muted">Cargando &oacute;rdenes...</small>
                                                        </div>
                                                    ) : (
                                                        <Alert variant="light" className="text-center py-4">
                                                            <FontAwesomeIcon icon="shopping-cart" size="2x" className="text-muted mb-2" />
                                                            <div className="text-muted">No hay &oacute;rdenes para esta suscripci&oacute;n</div>
                                                        </Alert>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    ) : (
                        <Alert variant="light" className="text-center py-4">
                            <FontAwesomeIcon icon="sync-alt" size="3x" className="text-muted mb-3" />
                            <h6 className="text-muted">No hay suscripciones registradas</h6>
                            <p className="text-muted mb-0">
                                Este cliente no tiene suscripciones activas o registradas en el sistema.
                            </p>
                        </Alert>
                    )}
                </Card.Body>

                {/* Modal Nueva Suscripción */}
                <ModalNuevaSuscripcion
                    show={showModalNuevaSuscripcion}
                    setShow={setShowModalNuevaSuscripcion}
                    idCliente={idCliente}
                    onSuscripcionCreada={obtenerSuscripcionesCliente}
                />

                {/* Modal Cancelar Suscripción */}
                <ModalSeguroCancelarSuscripcion
                    show={showModalCancelar}
                    onClose={() => {
                        setShowModalCancelar(false);
                        setSuscripcionACancelar(null);
                    }}
                    onConfirm={cancelarSuscripcion}
                    processing={cancelandoId !== null}
                    suscripcionInfo={suscripcionACancelar}
                />

                {/* Modal Recuperar Suscripción */}
                <ModalSeguroRecuperarSuscripcion
                    show={showModalRecuperar}
                    onClose={() => {
                        setShowModalRecuperar(false);
                        setSuscripcionARecuperar(null);
                    }}
                    onConfirm={recuperarSuscripcion}
                    processing={recuperandoId !== null}
                    suscripcionInfo={suscripcionARecuperar}
                />
            </Card>
        </ErrorBoundary>
    );
};

SeccionSuscripciones.propTypes = {
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default SeccionSuscripciones;